import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import Text from "@components/AppText";
import t from "@constants/localization";

const PATH = "screens/CLProfile/components/skipButton";

const BtnTextMapping = {
  gender: "",
  age: "",
  occupation: "",
  availability_hours: "",
  income: "",
  source: "",
  no_of_family_members: "",
  grocery_spending: "",
  vehicle: "",
  alternate_phone: "दूसरा फ़ोन नं. नहीं है",
};

export default function SkipButton(props) {
  const { handlePress = () => {}, isActive, index, btnField } = props;

  return (
    <TouchableOpacity
      onPress={() => handlePress(index)}
      style={[
        styles.button,
        {
          display: isActive ? "flex" : "none",
        },
      ]}
    >
      <Text style={styles.btnText}>
        {BtnTextMapping[btnField]
          ? BtnTextMapping[btnField]
          : t(`${PATH}/skip`)}
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    alignSelf: "flex-end",
    marginLeft: 10,
    marginBottom: 10,
    borderWidth: 1,
    borderRadius: 10,
    borderColor: "rgba(0, 0, 0, 0.1)",
    padding: 12,
    paddingHorizontal: 30,
  },
  btnText: {
    color: "black",
    fontFamily: "NotoSansDevanagari-Bold",
    position: "relative",
    top: 2,
  },
});
